<avn-loader [isLoading]="pending$ | async" avnTheme="warning"></avn-loader>
<avn-drawer-layout data-e2e="avn-drawer-layout">
  <avn-drawer-header [title]="'dashboardScope.dashboard.widgets-drawer.title' | transloco" (closeClicked)="onClose()"> </avn-drawer-header>
  <avn-drawer-content>
    <avn-treeview
      data-e2e="widget-settings"
      [dataSource]="datasource$ | async"
      [selectedNodeIds]="selectedWidgets$ | async"
      [multipleSelection]="true"
      [showSearch]="false"
      [maxLevel]="1"
      [firstSelectableLevel]="1"
      (selectionChanged)="onSelectionChange()"
      componentHeightInPx="auto"
    >
    </avn-treeview>
  </avn-drawer-content>
  <avn-drawer-footer>
    <avn-button data-e2e="btn-save" (actioned)="onSave()" [label]="'button.save' | transloco" avnTheme="primary" [disabled]="!canSave"> </avn-button>
    <avn-button (actioned)="onClose()" [label]="'button.cancel' | transloco"></avn-button>
  </avn-drawer-footer>
</avn-drawer-layout>
